// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"EditorSection_titleContainer__1RRTH","topTitle":"EditorSection_topTitle__2ZLQo"};